import { InternalAxiosRequestConfig } from 'axios';

declare module 'axios' {
    export interface InternalAxiosRequestConfig {
        /** Key nội bộ để track AbortController (unique mỗi request) */
        abortRequestKey?: string;
    }
}

class RequestManager {
    private pendingRequests: Map<string, AbortController>;
    private seq = 0;

    constructor() {
        this.pendingRequests = new Map();
    }

    private nextKey(config: InternalAxiosRequestConfig): string {
        this.seq += 1;
        const method = String(config.method || 'get').toLowerCase();
        const url = String(config.url || '');
        return `${method}-${url}-${this.seq}-${Date.now()}`;
    }

    addRequest(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
        const controller = new AbortController();
        const requestKey = config.abortRequestKey || this.nextKey(config);
        config.abortRequestKey = requestKey;
        this.pendingRequests.set(requestKey, controller);
        config.signal = controller.signal;
        return config;
    }

    removeRequest(config: InternalAxiosRequestConfig): void {
        const requestKey = config.abortRequestKey;
        if (!requestKey) return;
        this.pendingRequests.delete(requestKey);
    }

    cancelByPrefix(prefix: string): void {
        const matchingKeys = Array.from(this.pendingRequests.keys()).filter((key) => key.startsWith(prefix));
        matchingKeys.forEach((key) => {
            const controller = this.pendingRequests.get(key);
            controller?.abort();
            this.pendingRequests.delete(key);
        });
    }

    cancelAll(): void {
        this.pendingRequests.forEach((controller) => controller.abort());
        this.pendingRequests.clear();
    }
}

export default new RequestManager();
